import { ChevronDown } from "lucide-react";

// Compact size dropdown — single pill select with the size guide link
// tucked above it on the right.
export default function SizeSelector({
  groups,
  value,
  onChange,
  testIdPrefix = "size",
  onSizeGuide,
  label = null,
  thin = false,
}) {
  return (
    <div>
      <div className="flex items-center justify-between gap-3">
        {label && (
          <span
            data-testid={`${testIdPrefix}-label`}
            className="font-body font-bold text-sm sm:text-base"
          >
            {label}
          </span>
        )}
        {onSizeGuide && (
          <button
            data-testid={`${testIdPrefix}-guide-link`}
            type="button"
            onClick={onSizeGuide}
            className={`font-body font-semibold text-sm underline underline-offset-2 text-ink/60 hover:text-ink transition-colors ${label ? "" : "ml-auto"}`}
          >
            Size guide
          </button>
        )}
      </div>
      <div data-testid={`${testIdPrefix}-options`} className="mt-2 relative">
        <select
          data-testid={`${testIdPrefix}-select`}
          value={value || ""}
          onChange={(e) => onChange(e.target.value)}
          aria-label="Select your shoe size"
          className={`w-full min-h-[52px] bg-white pl-5 pr-11 font-body text-sm text-ink appearance-none cursor-pointer focus:outline-none ${
            thin
              ? "rounded-2xl border-[1.5px] border-ink/40 font-medium focus:border-ink"
              : "rounded-full border-2 border-ink font-semibold"
          }`}
        >
          <option value="" disabled>
            Select your size
          </option>
          {groups.map((g) => (
            <optgroup key={g.key} label={g.label}>
              {g.sizes.map((s) => (
                <option key={s} value={`${g.prefix}${s}`}>
                  {g.prefix}
                  {s}
                </option>
              ))}
            </optgroup>
          ))}
        </select>
        <ChevronDown
          className="absolute right-4 top-1/2 -translate-y-1/2 w-4 h-4 text-ink/50 pointer-events-none"
          strokeWidth={2.5}
        />
      </div>
    </div>
  );
}
